import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UserRole } from 'shared_models';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '../services/logger.service';
import { getProjectIdFromRoute } from './route-param.util';

/** Roles that must not use the field-operator / rework-entry interface. */
const ROLES_BLOCKED_FROM_OPERATOR: readonly UserRole[] = [
  UserRole.QualityControl,
  UserRole.Viewer,
];

/**
 * Restricts the Piled operator interface to roles that may enter installation / rework field data.
 * QC and viewers are redirected to QC or dashboard respectively.
 */
export const piledOperatorRoleGuard: CanActivateFn = async (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  const projectID = getProjectIdFromRoute(route);

  let user;
  try {
    user = await firstValueFrom(authService.getCurrentUser());
  } catch {
    return router.parseUrl('/login');
  }

  if (!user) {
    return router.parseUrl('/login');
  }

  if (!ROLES_BLOCKED_FROM_OPERATOR.includes(user.role)) {
    return true;
  }

  logger.warn('[PiledOperatorRoleGuard] Access denied for role:', user.role);

  if (!projectID) {
    return router.parseUrl('/landing');
  }

  const fallback =
    user.role === UserRole.QualityControl
      ? `/project/${projectID}/piled/qc`
      : `/project/${projectID}/piled/dashboard`;

  return router.parseUrl(fallback);
};
